import { makeRequest } from './https';

export const getProfile = () =>
  makeRequest({ url: '/settings/profile', method: 'get' });

export const updateProfile = (data: { name?: string | null; avatar?: string | null }) =>
  makeRequest({ url: '/settings/profile', method: 'put', data });

export const updatePassword = (data: { current_password: string; new_password: string }) =>
  makeRequest({ url: '/settings/password', method: 'put', data });

export const getGoogleStatus = () =>
  makeRequest({ url: '/settings/google', method: 'get' });

export const connectGoogle = (code: string) =>
  makeRequest({ url: '/settings/google/connect', method: 'post', data: { code } });

export const disconnectGoogle = () =>
  makeRequest({ url: '/settings/google/disconnect', method: 'delete' });
